import React from 'react';
export var Cross = function () { return (React.createElement("svg", { width: "24", height: "24", fill: "none", stroke: "currentColor", strokeWidth: "2", className: "dropdown-search-clear-icon gray" },
    React.createElement("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
    React.createElement("line", { x1: "6", y1: "6", x2: "18", y2: "18" }))); };



//////////////////
// WEBPACK FOOTER
// ./src/components/MultiSelect/select-panel/Cross.tsx
// module id = 500
// module chunks = 0